import { render, staticRenderFns } from "./filter_customer.vue?vue&type=template&id=62c5fae8"
import script from "./filter_customer.vue?vue&type=script&lang=js"
export * from "./filter_customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports